// removed by extract-text-webpack-plugin
module.exports = {"owner-container":"UpcomingOwner__owner-container___1OS14"};